import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontFamilies,
  palette,
  lineHeights,
  fontSizes,
  borderRadiuses,
  fontWeights,
}: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '0.75rem',
    padding: '1rem',
    border: `1px solid ${palette.grey['400']}`,
    borderRadius: borderRadiuses.md,
  },
  solutionsBrandLogo: {
    width: '7.5rem',
  },
  brandName: {
    margin: '0 0 5px 0',
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.sm,
    fontWeight: fontWeights.medium,
    lineHeight: lineHeights.md,
    color: palette.text.secondary,
  },
  description: {
    margin: 0,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xxs,
    color: palette.text.primary,
    lineHeight: lineHeights.xxs,
  },
}));
